import React from "react";
import { FaEdit, FaCog } from "react-icons/fa";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";

const currencyData = [
  {
    id: 1,
    name: "Dollar",
    symbol: "$",
    code: "USD",
    status: "Active",
  },
  {
    id: 2,
    name: "Rupee",
    symbol: "₹",
    code: "INR",
    status: "Active",
  },
];

const Currencies = () => {
  return (
    <motion.div
      className=" card container py-3"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      {/* PAGE TITLE */}
      <motion.h5
        className="fw-semibold mb-3 text-primary"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.1 }}
      >
        Currencies
      </motion.h5>

      {/* CARD */}
      <motion.div
        className="card shadow-sm border-0"
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
      >
        <div className="card-header bg-white fw-semibold">
          Currency List
        </div>

        <div className="card-body p-0">
          <table className="table align-middle mb-0">
            <thead className="table-light">
              <tr>
                <th><input type="checkbox" /></th>
                <th>Currencies</th>
                <th>Currency Symbol</th>
                <th>Currency Code</th>
                <th>Status</th>
                <th className="text-end">Actions</th>
              </tr>
            </thead>

            <tbody>
              {currencyData.map((item, index) => (
                <motion.tr
                  key={item.id}
                  initial={{ opacity: 0, y: 15 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  whileHover={{ scale: 1.01 }}
                >
                  <td>
                    <input type="checkbox" />
                  </td>

                  <td>{item.name}</td>
                  <td>{item.symbol}</td>
                  <td>{item.code}</td>

                  <td>
                    <motion.span
                      className="badge bg-success"
                      initial={{ scale: 0.8 }}
                      animate={{ scale: 1 }}
                      transition={{ delay: 0.2 }}
                    >
                      {item.status}
                    </motion.span>
                  </td>

                  <td className="text-end">
                    <motion.button
                      whileTap={{ scale: 0.8 }}
                      className="btn btn-sm btn-light me-2"
                    >
                      <FaEdit />
                    </motion.button>

                    <motion.button
                      whileHover={{ rotate: 90 }}
                      whileTap={{ scale: 0.8 }}
                      className="btn btn-sm btn-light"
                    >
                      <FaCog />
                    </motion.button>
                  </td>
                </motion.tr>
              ))}
            </tbody>
          </table>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default Currencies;